// DispositionForm.jsx
import React, { useState, useEffect } from "react";
import { API_REMARK_CREATE, API_REMARK_STATUS_LIST } from "../../../service/url";
import { postApiCall, getApiCall } from "../../../service/httpCall";
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import { PersonFill, Telephone, ChatLeftText, ListCheck, Send, PersonCircle } from "react-bootstrap-icons";

const Form = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    contactNumber: "",
    remarksText: "",
    selectedRemarkValue: [],
  });
  const [remarkOptions, setRemarkOptions] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);

  useEffect(() => {
    getApiCall(API_REMARK_STATUS_LIST, {})
      .then((resp) =>
        setRemarkOptions(resp))
      .catch((err) => console.error(err));
  }, []);

  // useEffect(() => {
  //   if (toastProps) setShowToast(true);
  // }, [toastProps]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (remark) => {
    setFormData((prev) => {
      const selected = prev.selectedRemarkValue || [];
      const newSelected = selected.includes(remark)
        ? selected.filter((r) => r !== remark)
        : [...selected, remark];
      return { ...prev, selectedRemarkValue: newSelected };
    });
  };

  const validateForm = () => {
    if (!formData.remarksText.trim()) {
      toast.warn('Remark is required')
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const data = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      mobile_number: formData.contactNumber,
      remark: [...formData.selectedRemarkValue, formData.remarksText],
    };

    postApiCall(API_REMARK_CREATE, data)
      .then(() => {
        toast.success("Remark Added successfully");
        setFormData({
          firstName: "",
          lastName: "",
          contactNumber: "",
          remarksText: "",
          selectedRemarkValue: [],
        });
      })
      .catch((err) => {
        toast.warning(JSON.stringify(err))
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit} style={{ padding: '10px' }}>
          <div className="mb-3" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {/* User Avatar Icon */}
            <div style={{ flexShrink: 0 }}>
              <PersonCircle size={85} color="#081d5d" />
            </div>
            
            {/* Fields Container */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {/* First Row: First Name and Last Name */}
              <div style={{ display: 'flex', gap: '12px' }}>
                <div style={{ flex: 1, position: 'relative' }}>
                  <PersonFill 
                    size={18} 
                    style={{ 
                      position: 'absolute', 
                      left: '12px', 
                      top: '50%', 
                      transform: 'translateY(-50%)', 
                      color: '#6c757d',
                      pointerEvents: 'none',
                      zIndex: 1
                    }} 
                  />
                  <input
                    name="firstName"
                    className="form-control"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    style={{ paddingLeft: '40px' }}
                    placeholder="First name"
                  />
                </div>
                <div style={{ flex: 1, position: 'relative' }}>
                  <PersonFill 
                    size={18} 
                    style={{ 
                      position: 'absolute', 
                      left: '12px', 
                      top: '50%', 
                      transform: 'translateY(-50%)', 
                      color: '#6c757d',
                      pointerEvents: 'none',
                      zIndex: 1
                    }} 
                  />
                  <input
                    name="lastName"
                    className="form-control"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    style={{ paddingLeft: '40px' }}
                    placeholder="Last name"
                  />
                </div>
              </div>
              
              {/* Second Row: Contact Number */}
              <div style={{ position: 'relative' }}>
                <Telephone 
                  size={18} 
                  style={{ 
                    position: 'absolute', 
                    left: '12px', 
                    top: '50%', 
                    transform: 'translateY(-50%)', 
                    color: '#6c757d',
                    pointerEvents: 'none',
                    zIndex: 1
                  }} 
                />
                <input
                  name="contactNumber"
                  className="form-control"
                  value={formData.contactNumber}
                  onChange={handleInputChange}
                  style={{ paddingLeft: '40px' }}
                  placeholder="Contact number"
                />
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label" style={{ fontWeight: '500', marginBottom: '8px' }}>
              Remarks
            </label>
            <div style={{ position: 'relative' }}>
              <ChatLeftText 
                size={18} 
                style={{ 
                  position: 'absolute', 
                  left: '12px', 
                  top: '18px', 
                  color: '#6c757d',
                  pointerEvents: 'none'
                }} 
              />
              <textarea
                name="remarksText"
                className="form-control"
                rows="3"
                value={formData.remarksText}
                onChange={handleInputChange}
                style={{ paddingLeft: '40px', paddingTop: '12px' }}
                placeholder="Enter your remarks here..."
              />
            </div>
          </div>

<div className="mb-3 mt-3">
  <label className="form-label" style={{ fontWeight: '500', marginBottom: '8px' }}>
    Select Remark
  </label>
  <div className="dropdown">
    <button
      className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style={{ 
        paddingLeft: '40px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
      }}
    >
      <ListCheck 
        size={18} 
        style={{ 
          position: 'absolute', 
          left: '12px', 
          color: '#6c757d',
          pointerEvents: 'none'
        }} 
      />
      <span style={{ marginLeft: '8px' }}>
        {formData.selectedRemarkValue.length === 0
          ? "Select remarks..."
          : `${formData.selectedRemarkValue.length} selected`}
      </span>
    </button>
    <ul className="dropdown-menu w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
      {remarkOptions.map((opt) => (
        <li key={opt.id}>
          <label className="dropdown-item" style={{ cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={formData.selectedRemarkValue.includes(opt.remark)}
              onChange={() => handleCheckboxChange(opt.remark)}
              className="me-2"
            />
            {opt.remark}
          </label>
        </li>
      ))}
    </ul>
  </div>

  {formData.selectedRemarkValue.length > 0 && (
    <div className="mt-2">
      {formData.selectedRemarkValue.map((val) => (
        <span key={val} className="badge bg-primary me-1 mb-1" style={{ fontSize: '0.85em', padding: '6px 10px' }}>
          {val}
          <button
            type="button"
            className="btn-close btn-close-white ms-1"
            style={{ fontSize: '0.6em' }}
            onClick={() => handleCheckboxChange(val)}
          ></button>
        </span>
      ))}
    </div>
  )}
</div>
          <button
            type="submit"
            className="btn btn-primary w-100"
            style={{
              backgroundColor: '#081d5d', 
              borderColor: '#081d5d',
              color: 'white',
              padding: '12px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              marginTop: '10px',
              borderRadius: '8px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#0a2569';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 8px rgba(8, 29, 93, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#081d5d';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            <Send size={18} />
            Submit
          </button>

        </form>


      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};

export default Form;
